import {LoginMethod} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/storefrontAuthenticationWorkspaceCapability/domain/StorefrontAuthentication";
import {z as zod} from "zod";

export type StorefrontAuthenticationOtpSmsDeliveryConfiguration = {
    from: string;
    messageTemplate: string;
    password: string;
    templateId: string;
    username: string;
};

export type StorefrontAuthenticationOtpWhatsAppDeliveryConfiguration = {
    apiKey: string;
    campaignId: string;
    sender: string;
    templateLanguage: string;
    templateName: string;
};

export type StorefrontAuthenticationOtpDeliveryConfiguration = {
    sms: StorefrontAuthenticationOtpSmsDeliveryConfiguration;
    whatsapp: StorefrontAuthenticationOtpWhatsAppDeliveryConfiguration;
};

export type StorefrontAuthenticationWorkspaceCapabilityConfiguration = {
    allowedLoginMethods: Array<LoginMethod>;
    maxFailedLoginAttempts: number;
    otpDelivery: StorefrontAuthenticationOtpDeliveryConfiguration | null;
    otpExpiryWindowMinutes: number;
};

const storefrontAuthenticationOtpSmsDeliveryConfigurationValidator: zod.ZodType<StorefrontAuthenticationOtpSmsDeliveryConfiguration> = zod.strictObject({
    from: zod.string().min(1),
    messageTemplate: zod.string().min(1),
    password: zod.string().min(1),
    templateId: zod.string().min(1),
    username: zod.string().min(1),
});

const storefrontAuthenticationOtpWhatsAppDeliveryConfigurationValidator: zod.ZodType<StorefrontAuthenticationOtpWhatsAppDeliveryConfiguration> = zod.strictObject({
    apiKey: zod.string().min(1),
    campaignId: zod.string().min(1),
    sender: zod.string().min(1),
    templateLanguage: zod.string().min(1),
    templateName: zod.string().min(1),
});

const storefrontAuthenticationOtpDeliveryConfigurationValidator: zod.ZodType<StorefrontAuthenticationOtpDeliveryConfiguration> = zod.strictObject({
    sms: storefrontAuthenticationOtpSmsDeliveryConfigurationValidator,
    whatsapp: storefrontAuthenticationOtpWhatsAppDeliveryConfigurationValidator,
});

export const storefrontAuthenticationWorkspaceCapabilityConfigurationValidator: zod.ZodType<StorefrontAuthenticationWorkspaceCapabilityConfiguration> = zod.strictObject({
    allowedLoginMethods: zod.enum(LoginMethod).array(),
    maxFailedLoginAttempts: zod.number().int().positive(),
    otpDelivery: storefrontAuthenticationOtpDeliveryConfigurationValidator.nullable(),
    otpExpiryWindowMinutes: zod.number().int().positive(),
});
